/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import {
  APP_INITIALIZER,
  DoBootstrap,
  Injector,
  NgModule,
} from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { QqcModule } from '@nibtravel/qqc/feature-shell/qqc';
import { BrandContentResolver } from '@nibtravel/shared/data-access/ui-content';
import { UnderwriterContentResolver } from '@nibtravel/shared/data-access/underwriter';
import { ThemeModule } from '@nibtravel/shared/ui/theme';
import {
  AppConfigModule,
  AppInitializerService,
} from '@nibtravel/shared/util/app-config';
import { AppLoaderModule } from '@nibtravel/shared/util/app-loader';
import { Resolver } from '@nibtravel/shared/util/constants';
import { i18nModule } from '@nibtravel/shared/util/i18n';
import { LoggerModule } from '@nibtravel/shared/util/logger';

import { environment } from '../environments/environment';
import { CustomAppConfigService } from './app-config-widget.service';
import { AppComponent } from './app.component';
import { QqcAppFactory, QqcAppInitializer } from './app.initializer';
import { UrlParamService } from './urlParam/urlParam.service';
import { CookiesDataService } from '@nibtravel/shared/data-access/cookies';

const sessionStorageStateObjects = [
  'quote',
  'quoteConfig',
  'underwriter',
  'countries',
];
let storagePluginOpt = {
  storage: StorageOption.SessionStorage,
};

// On dev mode, we need all state objects to be on sessionStorage, but only few on prod
if (environment.production) {
  storagePluginOpt = {
    ...storagePluginOpt,
    ...{ keys: sessionStorageStateObjects },
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    NgxsModule.forRoot([], { developmentMode: !environment.production }),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    NgxsStoragePluginModule.forRoot(storagePluginOpt),
    RouterModule.forRoot([]),
    AppConfigModule.forRoot(environment, CustomAppConfigService),
    AppLoaderModule,
    LoggerModule.forRoot(),
    QqcModule,
    ThemeModule,
    i18nModule.forRoot({
      defaultLang: 'en',
      availableLangs: ['en', 'pt-br'],
      fallbackLang: 'en',
      resolvers: [
        {
          key: Resolver.BrandContent,
          resolver: BrandContentResolver,
        },
        {
          key: Resolver.UnderwriterContent,
          resolver: UnderwriterContentResolver,
        },
      ],
    }),
  ],
  providers: [
    CookiesDataService,
    UrlParamService,
    QqcAppInitializer,
    CustomAppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: QqcAppFactory,
      deps: [AppInitializerService, QqcAppInitializer],
      multi: true,
    },
  ],
})
export class AppModule implements DoBootstrap {
  constructor(private injector: Injector, utmService: UrlParamService) {
    utmService.setPartnerCookie();
  }
  ngDoBootstrap() {
    const element = createCustomElement(AppComponent, {
      injector: this.injector,
    });
    customElements.define('tvl-qqc', element);
  }
}
